import { useRef, type KeyboardEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { abasVisiveis, proximaAba } from './catalogo';
import { useSessao } from '../auth/sessao';
import { useContadores } from '../dados/contadores';
import { Contador } from '../componentes/Estado';

// A aba é um <button> dentro de role=tablist, com aria-selected e aria-controls
// apontando para o painel — igual ao index.html. O que muda é que agora a aba
// ativa está na URL: `switchTab` não mexia na barra de endereços, então ninguém
// conseguia mandar "olha a aba de saúde do gw-azure" por mensagem.
export function Abas({ slug, ativa }: { slug: string; ativa: string }) {
  const { admin } = useSessao();
  const navegar = useNavigate();
  const abas = abasVisiveis(admin);
  const refs = useRef<Array<HTMLButtonElement | null>>([]);
  const contadores = useContadores(slug);

  function noTeclado(e: KeyboardEvent<HTMLDivElement>) {
    const atual = refs.current.findIndex((el) => el === document.activeElement);
    const alvo = proximaAba(abas, atual, e.key);
    if (alvo === null) return;
    e.preventDefault();
    refs.current[alvo]?.focus();
    navegar(`/p/${slug}/${abas[alvo].id}`);
  }

  return (
    <div className="tabs" role="tablist" aria-label="Seções do projeto" onKeyDown={noTeclado}>
      {abas.map((aba, i) => {
        const on = aba.id === ativa;
        return (
          <button
            key={aba.id}
            ref={(el) => { refs.current[i] = el; }}
            type="button"
            role="tab"
            className={`tab${on ? ' active' : ''}`}
            aria-selected={on}
            aria-controls={`pane-${aba.id}`}
            // só a aba ativa entra na ordem do Tab: é o padrão de tablist, e é
            // o que evita treze paradas de Tab antes de chegar ao conteúdo
            tabIndex={on ? 0 : -1}
            onClick={() => navegar(`/p/${slug}/${aba.id}`)}
          >
            {aba.rotulo}
            {/* o badge tem três estados, como no painel atual: carregando,
                número real (inclusive zero) e falha declarada com o motivo */}
            {aba.contador && <Contador {...(contadores[aba.id] || { estado: 'carregando' })} />}
          </button>
        );
      })}
    </div>
  );
}
